import { useEffect } from 'react';
import { useModal } from '@/shared/providers/ModalProvider';
import { useSyncContext } from '@/features/sync/context/SyncProvider';
import { useSyncStore } from '@/features/sync/stores/useSyncStore';

export const useKeyboardCommands = () => {
  const { toggleModal } = useModal();
  const syncLoading = useSyncStore(state => state.syncLoading);
  const { handleSync } = useSyncContext();

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key.toLocaleLowerCase() === 's' && (e.metaKey || e.ctrlKey) && !syncLoading) {
        e.preventDefault();
        handleSync();
      }
      if (e.key.toLocaleLowerCase() === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        toggleModal('search');
      }
    };

    document.addEventListener('keydown', down);
    return () => {
      document.removeEventListener('keydown', down);
    };
  }, [handleSync, syncLoading, toggleModal]);
};
